import type { FunctionComponent, ReactNode } from "react"

import Image from "next/image"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Text } from "@jobteaser/spark/components/Text"

import EmptyStateIcon from "@/modules/layouts/components/State/assets/empty.svg"

import styles from "@/modules/layouts/components/State/State.module.css"

type EmptyStateProps = {
  description: string
  icon?: ReactNode
  title: string
}

export const EmptyState: FunctionComponent<EmptyStateProps> = ({ description, icon, title, ...props }) => {
  return (
    <div {...props} className={styles.main}>
      {icon || <Image src={EmptyStateIcon} alt="" width={104} height={104} priority />}
      <Heading variant="title3" as="h3" className={styles.title}>
        {title}
      </Heading>
      <Text variant="body1" className={styles.description}>
        {description}
      </Text>
    </div>
  )
}
